import React, { ChangeEvent } from 'react';

import { ValueBox, ValueGroup, ValueInput } from '@candu-ai/craft/ui';
import { VariableHelp, VariableSummary } from 'craft/components/ToolboxVariable';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks/useMultiNodes/useMultiNodes';

interface Props {
  nodeIds: string[];
}

export const IFrameToolbox = ({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const onSrcChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setProps({ src: value });
  };

  return (
    <Section name="Properties">
      <ValueGroup>
        <ValueBox label="URL">
          <ValueInput
            value={props.src.value}
            onChange={onSrcChange}
            placeholder="wwww.example.com"
          />
        </ValueBox>
      </ValueGroup>
      {props.src.value ? <VariableSummary url={props.src.value} /> : null}
      <VariableHelp />
    </Section>
  );
};
